import { generateTraceparent } from '../lib/GenerateTraceparent';
import { fetchWithRefresh } from './FetchWithRefresh';

export const tracedFetch: typeof fetch = (input, init) => {
  const { traceparent } = generateTraceparent();
  const headers = new Headers(init === undefined ? undefined : init.headers);
  if (!headers.has('traceparent')) {
    headers.set('traceparent', traceparent);
  }
  return fetchWithRefresh(input, { ...init, headers });
};
